import "../Styles/Business_set.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  edit_client,
  update_profile_photo,
  check_phone_no,
  get_client_relations,
  get_relations,
  get_states,
  get_cities,
} from "../api/serverWrapper";
import { useEffect, useState } from "react";
import Select from "react-select";
import UserSystemRole from "../components/UserSystemRole";
import { IoChevronBackOutline } from "react-icons/io5";
import { loginByGoogle, loginByPhoneNo } from "../utils/Constants";
import { customStylesbusiness } from "../utils/commonFunctions";
import { useMasterData } from "../context/MasterDataContext";

function EditClient_set_up() {
  const navigate = useNavigate();
  const location = useLocation();
  const clientDetails = location.state;
  const { allCountyMasterData, countryMasterData, communityMasterData } =
    useMasterData();

  console.log(clientDetails);

  const [ClientFirstName, setClientFirstName] = useState(
    clientDetails?.FirstName || "",
  );
  const [ClientLastName, setClientLastName] = useState(
    clientDetails?.LastName || "",
  );

  const [CountyCode, setCountyCode] = useState(
    clientDetails?.CountyCode || "91",
  );

  const [PhoneNumber, setPhoneNumber] = useState(
    clientDetails?.PhoneNumber || "",
  );
  const [OrignalPhoneNuber, setOrignalPhoneNuber] = useState(
    clientDetails?.PhoneNumber || "",
  );
  const [selectedGender, setSelectedGender] = useState(
    clientDetails?.Gender || 1,
  );
  const [description, setDescription] = useState(
    clientDetails?.ClientDescreption || "",
  );

  const [ClientRelationId, setClientRelationId] = useState(
    clientDetails?.ParentId || null,
  );
  const [relations, setRelations] = useState([]);

  const [imageSource, setImageSource] = useState(
    clientDetails?.ProfilePhotoUrl,
  );
  const [selectedImage, setSelectedImage] = useState(null);

  /* ---------------- COUNTRY / STATE / CITY ---------------- */
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState(
    clientDetails?.Address?.CountryId || "",
  );
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(
    clientDetails?.Address?.StateId || "",
  );
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(
    clientDetails?.Address?.CityId || "",
  );
  const [addressDetails, setAddressDetails] = useState(
    clientDetails?.Address?.AddressDetails || "",
  );

  /* ---------------- RESIDENCE / CITIZENSHIP / ETHNICITY / POSTAL CODE ---------------- */
  const [countryList, setCountryList] = useState(countryMasterData || []);
  const [communityList, setCommunityList] = useState(
    communityMasterData || [],
  );
  const [selectedResidence, setSelectedResidence] = useState(
    clientDetails?.Address?.ResidenceId || "",
  );
  const [selectedCitizenship, setSelectedCitizenship] = useState(
    clientDetails?.Address?.CitizenshipId || "",
  );
  const [seletedEthinicity, setSelectedEthinicity] = useState(
    clientDetails?.Address?.Ethinicity || "",
  );
  const [postalcode, setPostalCode] = useState(
    clientDetails?.Address?.PostalCode || "",
  );

  useEffect(() => {
    loadRelations();
    fetchCountries();
  }, []);

  useEffect(() => {
    if (countryMasterData) setCountryList(countryMasterData);
  }, [countryMasterData]);

  useEffect(() => {
    if (communityMasterData) setCommunityList(communityMasterData);
  }, [communityMasterData]);

  const loadRelations = async () => {
    try {
      const resp = await get_relations();
      console.log(resp);

      if (resp.success) {
        let filterrelations = resp.data.filter((item) =>
          [1, 2, 7, 8, 10, 11].includes(item.RelationshipId),
        );
        console.log(filterrelations);

        setRelations(resp.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  /* ---------------- FETCH COUNTRIES ---------------- */
  const fetchCountries = async () => {
    try {
      const data = allCountyMasterData;

      if (data) {
        const formatted = data.flatMap((c) => {
          const phonecode = c.phonecode?.toString() || "";

          const phoneCodes = phonecode
            .split(/\s+and\s+/i)
            .map((code) => code.trim())
            .filter(Boolean);

          return phoneCodes.map((fullCode) => {
            const rawCode = fullCode.split("-")[0];
            const displayCode = rawCode.startsWith("+")
              ? rawCode
              : `+${rawCode}`;

            return {
              // ORIGINAL isoCode -> backend
              value: c.isoCode,
              // display label
              label: `${c.name} (${displayCode})`,
              name: c.name,
              phoneCode: c.phonecode,
            };
          });
        });

        setCountries(formatted);
      }
    } catch (err) {
      console.error("Error fetching countries", err);
    }
  };

  /* ---------------- FETCH STATES ---------------- */
  useEffect(() => {
    if (countryCode) {
      (async () => {
        try {
          const res = await get_states(countryCode);
          if (res.success) {
            const formattedStates = res.data.map((s) => ({
              value: s.isoCode,
              label: s.name,
              countryCode: s.countryCode,
            }));
            setStates(formattedStates);
          }
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      })();
    }
  }, [countryCode]);

  /* ---------------- FETCH CITIES ---------------- */
  useEffect(() => {
    if (countryCode && selectedState) {
      (async () => {
        try {
          const res = await get_cities(countryCode, selectedState);
          if (res.success) {
            const formattedCities = res.data.map((c) => ({
              value: c.name,
              label: c.name,
              stateCode: c.stateCode,
              countryCode: c.countryCode,
            }));
            setCities(formattedCities);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      })();
    }
  }, [selectedState, countryCode]);

  const renderRelationForClient = () => {
    return relations.map((item, index) => (
      <option key={index} value={item.RelationshipId}>
        {item.RelationshipName}
      </option>
    ));
  };

  const handleResidence = (e) => {
    setSelectedResidence(e.target.value ? Number(e.target.value) : "");
  };

  const handleCitizenship = (e) => {
    setSelectedCitizenship(e.target.value ? Number(e.target.value) : "");
  };

  const handleEthinicity = (e) => {
    setSelectedEthinicity(e.target.value ? Number(e.target.value) : "");
  };

  const handlePostalcode = (e) => {
    setPostalCode(e.target.value);
  };

  const showToast = (message) => {
    const toast = document.getElementById("toast-message");
    if (!toast) return;
    toast.innerText = message;
    toast.style.display = "block";
    void toast.offsetWidth;
    toast.style.animation = "fadeInOut 3s ease-in-out";
    setTimeout(() => (toast.style.display = "none"), 3000);
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const UpdateClient = async () => {
    if (!ClientFirstName.trim()) return showToast("Enter First Name");
    if (!ClientLastName.trim()) return showToast("Enter Last Name");
    if (!PhoneNumber) return showToast("Phone number is required");
    if (clientDetails?.ParentId) {
      if (!ClientRelationId) return showToast("Select Relationship");
    }

    if (OrignalPhoneNuber !== PhoneNumber) {
      if (PhoneNumber.length < 5 || PhoneNumber.length > 15) {
        return showToast("Enter valid contact Number");
      }
    }

    // Check phone only if changed
    if (PhoneNumber !== clientDetails.PhoneNumber) {
      const result = await check_phone_no(PhoneNumber);
      if (!result.success) {
        showToast("User with this phone number already exists");
        return;
      }
    }

    // Country / State / City required, rest optional (matches backend)
    if (!countryCode) return showToast("Select Country");
    if (!selectedState) return showToast("Select State");
    if (!selectedCity) return showToast("Select City");

    setIsSubmitting(true);

    const Address = {
      CountryId: countryCode,
      StateId: selectedState,
      CityId: selectedCity,
      AddressDetails: addressDetails?.trim() ? addressDetails.trim() : null,
    };

    if (selectedResidence) Address.ResidenceId = selectedResidence;
    if (selectedCitizenship) Address.CitizenshipId = selectedCitizenship;
    if (seletedEthinicity) Address.Ethinicity = seletedEthinicity;
    if (postalcode) Address.PostalCode = postalcode;

    const updatedData = {
      userInfo: {
        UserId: clientDetails.UserId,
        FirstName: ClientFirstName,
        LastName: ClientLastName,
        PhoneNumber,
        Gender: selectedGender,
        SystemRole: UserSystemRole.CLIENT.id,
      },
      ClientDescreption: description,
      ParentId: ClientRelationId,
      Address,
    };

    if (!clientDetails?.ParentId) {
      delete updatedData.ParentId;
    }

    try {
      const resp = await edit_client(updatedData);
      console.log(resp);

      if (resp.code === 200) {
        if (selectedImage) {
          await update_profile_photo(clientDetails.UserId, selectedImage);
        }
        navigate("/settings");
      } else {
        showToast(resp.message);
      }
    } catch (error) {
      console.error(error);
      showToast("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleImageSelection = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImageSource(URL.createObjectURL(file));
    setSelectedImage(file);
  };

  return (
    <div>
      <div className="client-setup-header-main">
        <div className="client-setup-header-left">
          <IoChevronBackOutline
            className="client-setup-back-icon"
            onClick={() => navigate("/settings")}
          />

          <img
            src={require("../assests/images/nav_bar_logo.png")}
            alt="Wedluk Logo"
            className="client-setup-logo"
          />
        </div>

        <div className="client-setup-header-right">
          {/* <span>Client Sign up | Client setup</span> */}
        </div>
      </div>
      <div className="Business_background_color">
        <div className="Client-container">
          <h2>Client Overview</h2>

          {clientDetails?.ParentId && (
            <div className="field">
              <label>Select Relationship</label>
              <select
                value={ClientRelationId || ""}
                onChange={(e) => setClientRelationId(Number(e.target.value))}
              >
                <option value="">Select Relationship</option>
                {renderRelationForClient()}
              </select>
            </div>
          )}

          <div className="field">
            <label>Enter Phone Number</label>
            <input
              type="text"
              value={PhoneNumber}
              disabled={clientDetails?.LoginBy === loginByPhoneNo}
              maxLength={14}
              onChange={(e) =>
                setPhoneNumber(e.target.value.replace(/\D/g, ""))
              }
            />
          </div>

          <div className="field">
            <label>First Name</label>
            <input
              type="text"
              value={ClientFirstName}
              onChange={(e) => setClientFirstName(e.target.value)}
            />
          </div>

          <div className="field">
            <label>Last Name</label>
            <input
              type="text"
              value={ClientLastName}
              onChange={(e) => setClientLastName(e.target.value)}
            />
          </div>

          {/* <div className="gender-container">
            <div>Select Gender</div>
            <div className="d-flex">
              <input
                type="radio"
                value={1}
                checked={selectedGender === 1}
                onChange={(e) => setSelectedGender(Number(e.target.value))}
              />{" "}
              Male
              <input
                type="radio"
                value={2}
                checked={selectedGender === 2}
                onChange={(e) => setSelectedGender(Number(e.target.value))}
              />{" "}
              Female
            </div>
          </div> */}

          <div className="field">
            <label>Select Country *</label>
            <div className="form-group-new-client">
              <Select
                options={countries}
                placeholder="Select Country"
                value={countries.find((c) => c.value === countryCode) || null}
                onChange={(option) => {
                  setCountryCode(option ? option.value : "");
                  setSelectedState("");
                  setSelectedCity("");
                }}
                isSearchable
                isDisabled={true}
                styles={customStylesbusiness}
              />
            </div>
          </div>

          <div className="field">
            <label>Select State *</label>
            <Select
              options={states}
              placeholder="Select State"
              value={states.find((s) => s.value === selectedState) || null}
              onChange={(option) => {
                setSelectedState(option ? option.value : "");
                setSelectedCity("");
              }}
              isDisabled={!countryCode}
              isSearchable
              styles={customStylesbusiness}
            />
          </div>

          <div className="field">
            <label>Select City *</label>
            <Select
              options={cities}
              placeholder="Select City"
              value={cities.find((c) => c.value === selectedCity) || null}
              onChange={(option) => setSelectedCity(option ? option.value : "")}
              isDisabled={!selectedState}
              isSearchable
              styles={customStylesbusiness}
            />
          </div>

          <div className="field">
            <label>Address Details (Optional)</label>
            <textarea
              placeholder="House no, street, landmark, etc."
              value={addressDetails}
              onChange={(e) => setAddressDetails(e.target.value)}
              rows={3}
            />
          </div>

          <div className="field">
            <label>Select Residence</label>
            <select value={selectedResidence} onChange={handleResidence}>
              <option value="">Select Residence</option>
              {countryList?.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.CountryName} ({country.CountryCode})
                </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label>Select Citizenship</label>
            <select value={selectedCitizenship} onChange={handleCitizenship}>
              <option value="">Select Citizenship</option>
              {countryList?.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.CountryName} ({country.CountryCode})
                </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label>Select Ethinicity</label>
            <select value={seletedEthinicity} onChange={handleEthinicity}>
              <option value="">Select Ethinicity</option>
              {communityList?.map((community) => (
                <option
                  key={community.CommunitiesId}
                  value={community.CommunitiesId}
                >
                  {community.CommunitiesName}
                </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label>Postal Code</label>
            <input
              type="text"
              value={postalcode}
              onChange={handlePostalcode}
              placeholder="Enter Postal Code"
            />
          </div>

          <div className="field">
            <label>Client Description</label>
            <textarea
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>

        <div className="profile-image">
          <h2>Profile Photo</h2>
          <div className="Business_symbol">
            <label htmlFor="imageUpload" className="upload-label">
              <img src={imageSource} alt="Preview" className="preview-image" />
              <div className="plus-icon-for-agent">+</div>
            </label>

            <input
              id="imageUpload"
              type="file"
              accept="image/*"
              onChange={handleImageSelection}
              className="hidden-input"
            />
          </div>
        </div>

        <div className="footer-reg">
          <div
            onClick={!isSubmitting ? UpdateClient : undefined}
            style={{
              pointerEvents: isSubmitting ? "none" : "auto",
              opacity: isSubmitting ? 0.6 : 1,
              cursor: isSubmitting ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <h3 style={{ margin: 0 }}>
              {isSubmitting ? "Submitting" : "Save Changes ›"}
            </h3>

            {isSubmitting && <span className="spinner" />}
          </div>
        </div>
      </div>

      <div id="toast-message"></div>
    </div>
  );
}

export default EditClient_set_up;
